import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchDownloadConversationFailure,
  fetchDownloadConversationSuccess,
} from "../slices/features/uploadContacts";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* downloadConversationsSaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.downloadConversation,
      baseUrl,
      id
    );

    yield put(fetchDownloadConversationSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchDownloadConversationFailure({ statusCode, statusText }));
  }
}

export function* watchDownlaodConversations() {
  yield takeLatest(
    RequestTypes.EXPORT_CONVERSATION_REQUEST,
    downloadConversationsSaga
  );
}
